
import AppSettings from "./AppSettings";
import axios from "axios";
export const LoginService = {
// async getData (apiname:any, data:any) {
//   const rep = await fetch(`${AppSettings.BASE_URL()}${apiname}`, {
//     method: "POST",
//     body: JSON.stringify(data),
//     headers: {
//       'Content-Type': 'application/x-www-form-urlencoded',
//     },
//   });
//   const json = await rep.json();

//   return json;
// },
async getData (apiname:any, data:any) {
  let liveUrl = sessionStorage.getItem('Locationsurls');
  let apiliveurl = sessionStorage.getItem('baseDomain');
  let apiRoot = sessionStorage.getItem('apiRoot');
  let data1 = {...data, liveUrl,apiliveurl,apiRoot}
  const rep = await fetch(`${AppSettings.BASE_URL()}${apiname}`, {
    method: "POST",
    body: JSON.stringify(data1),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
  const json = await rep.json();

  return json;
},
 async getDatas(apiname: any, data:any): Promise<any> {
  try {
    let liveUrl = sessionStorage.getItem('Locationsurls');
    let apiliveurl = sessionStorage.getItem('baseDomain');
    let apiRoot = sessionStorage.getItem('apiRoot');
    let data1 = {...data, liveUrl,apiliveurl,apiRoot}
    const apiUrl = `${AppSettings.BASE_URL()}${apiname}`;
    const response = await axios.post(apiUrl, data1, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from ${apiname}`, error);
    throw error;
  }
},
async uploadimage(apiname: any, formdata:any): Promise<any> {
  try {
    const apiUrl = `${AppSettings.BASE_URL()}${apiname}`;
    const response = await axios.post(apiUrl, formdata, {
      headers: {
        
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from ${apiname}`, error);
    throw error;
  }
},
async  getfooter(data: any): Promise<any> {
  try {
      const apiUrl = 'https://support.jwtechinc.com/ws_an_footer.php'; // Directly specify the URL here
      const payload = {projectname:data}
      const response = await axios.post(apiUrl, payload, {
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
          },
      });
      return response.data;
  } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
  }
},
  async getFooter1 (data:any) {
    const apiUrl = 'https://support.jwtechinc.com/ws_an_footer.php'; // Directly specify the URL here
    const rep = await fetch(apiUrl, {
      method: "POST",
      //body: JSON.stringify(data),
      body: JSON.stringify({ ...data}),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const json = await rep.json();
  
    return json;
  },

 async getcountry(apiname:any) {
  {
    const apiUrl = `${AppSettings.BASE_URL()}${apiname}`;
    const response = await axios.post(apiUrl,{
      // headers: {
      
    });
    return response.data;
  }
 }

}
